import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, FlaskConical, Baby, User, Heart, Dog, Beef, Fish, Activity, Apple, Sparkles, Cookie } from 'lucide-react';

const filterConfig = {
  type: {
    label: 'Type',
    options: [
      { value: 'grain_free', label: 'Grain Free', icon: Leaf },
      { value: 'hydrolysed', label: 'Hydrolysed', icon: FlaskConical },
      { value: 'superfoods', label: 'Superfoods', icon: Sparkles },
      { value: 'functional_treats', label: 'Functional Treats', icon: Cookie },
    ],
  },
  lifestage: {
    label: 'Life Stage',
    options: [
      { value: 'puppy', label: 'Puppy', icon: Baby },
      { value: 'adult', label: 'Adult', icon: User },
      { value: 'senior', label: 'Senior', icon: Heart },
    ],
  },
  breed_size: {
    label: 'Breed Size',
    options: [
      { value: 'large', label: 'Large Breed', icon: Dog },
      { value: 'small', label: 'Small Breed', icon: Dog },
    ],
  },
  benefits: {
    label: 'Special Benefits',
    options: [
      { value: 'digestive_support', label: 'Digestive Support', icon: Activity },
      { value: 'novel_protein', label: 'Novel Protein', icon: Apple },
      { value: 'fish_based', label: 'Fish Based', icon: Fish },
      { value: 'meat_based', label: 'Meat Based', icon: Beef },
      { value: 'immune_support', label: 'Immune Support', icon: Activity },
      { value: 'calming_support', label: 'Calming Support', icon: Heart },
      { value: 'dental_support', label: 'Dental Support', icon: Activity },
      { value: 'skin_coat', label: 'Skin & Coat', icon: Activity },
    ],
  },
};

export const FilterBar = ({ filters, setFilters }) => {
  const toggleFilter = (category, value) => {
    setFilters((prev) => ({
      ...prev,
      [category]: prev[category] === value ? null : value,
    }));
  };

  const clearFilters = () => {
    setFilters({ type: null, lifestage: null, breed_size: null, benefits: null });
  };

  const hasActiveFilters = Object.values(filters).some((v) => v !== null);

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-3 sm:p-4 shadow-sm" data-testid="filter-bar">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-bold text-[#222] text-sm sm:text-base">Filter Products</h3>
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="text-xs sm:text-sm text-[#0FA49C] font-medium hover:underline"
            data-testid="clear-filters-btn"
          >
            Clear all
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {Object.entries(filterConfig).map(([category, config]) => (
          <div key={category}>
            <p className="text-xs sm:text-sm font-medium text-[#666] mb-1.5">{config.label}</p>
            <div className="flex flex-wrap gap-1.5">
              {config.options.map((option) => {
                const Icon = option.icon;
                const isActive = filters[category] === option.value;
                
                return (
                  <motion.button
                    key={option.value}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => toggleFilter(category, option.value)}
                    className={`filter-chip flex items-center gap-1 px-2 sm:px-2.5 py-1 sm:py-1.5 rounded-lg text-xs sm:text-sm font-medium border ${
                      isActive
                        ? 'bg-[#0FA49C] text-white border-[#0FA49C]'
                        : 'bg-white text-[#222] border-gray-200 hover:border-[#0FA49C]/50'
                    }`}
                    data-testid={`filter-${category}-${option.value}`}
                  >
                    <Icon className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                    <span className="whitespace-nowrap">{option.label}</span>
                  </motion.button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
